<template>
  <v-card class="glass-effect">
    <v-card-title class="headline">
      <v-icon large left>mdi-cart</v-icon>
      مدیریت سفارشات
      <v-spacer></v-spacer>
      <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="جستجو"
          single-line
          hide-details
          class="search-field"
      ></v-text-field>
    </v-card-title>

    <v-card-text>
      <v-row>
        <v-col cols="12" sm="6" md="3">
          <v-select
              v-model="statusFilter"
              :items="statusOptions"
              label="فیلتر بر اساس وضعیت"
              multiple
              clearable
          ></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-menu
              v-model="dateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  v-model="dateRangeText"
                  label="فیلتر تاریخ"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
                v-model="dateRange"
                range
                no-title
                scrollable
                @input="dateMenu = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-text-field
              v-model="trackingFilter"
              label="فیلتر کد رهگیری"
              clearable
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-text-field
              v-model="customerFilter"
              label="فیلتر مشتری"
              clearable
          ></v-text-field>
        </v-col>
      </v-row>

      <v-data-table
          v-model="selected"
          :headers="headers"
          :items="orders"
          :search="search"
          :loading="loading"
          loading-text="در حال بارگذاری... لطفا صبر کنید"
          :items-per-page="10"
          :footer-props="{
          'items-per-page-options': [10, 25, 50, 100],
          'show-first-last-page': true,
        }"
          show-select
          class="elevation-1"
          locale="fa-IR"
      >
        <template v-slot:item.status="{ item }">
          <v-chip :color="getStatusColor(item.status)" dark>
            {{ getStatusText(item.status) }}
          </v-chip>
        </template>

        <template v-slot:item.total_price="{ item }">
          {{ formatPrice(item.total_price) }}
        </template>

        <template v-slot:item.final_amount="{ item }">
          {{ formatPrice(item.final_amount) }}
        </template>

        <template v-slot:item.date_time="{ item }">
          {{ formatDate(item.date_time) }}
        </template>

        <template v-slot:item.actions="{ item }">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item @click="viewOrder(item)">
                <v-list-item-icon>
                  <v-icon small>mdi-eye</v-icon>
                </v-list-item-icon>
                <v-list-item-title>مشاهده جزئیات</v-list-item-title>
              </v-list-item>
              <v-list-item @click="editOrder(item)">
                <v-list-item-icon>
                  <v-icon small>mdi-pencil</v-icon>
                </v-list-item-icon>
                <v-list-item-title>ویرایش</v-list-item-title>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item @click="changeStatusDialog(item)">
                <v-list-item-icon>
                  <v-icon small>mdi-swap-horizontal</v-icon>
                </v-list-item-icon>
                <v-list-item-title>تغییر وضعیت</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </v-card-text>

    <v-card-actions v-if="selected.length > 0" class="bulk-actions">
      <v-select
          v-model="bulkAction"
          :items="bulkActions"
          label="عملیات گروهی"
          item-text="text"
          item-value="value"
          dense
          outlined
          class="mr-2"
          style="max-width: 200px;"
      ></v-select>
      <v-btn color="primary" @click="applyBulkAction" :loading="bulkLoading">
        اعمال
      </v-btn>
      <v-btn text @click="selected = []">انصراف</v-btn>
    </v-card-actions>

    <!-- Change Status Dialog -->
    <v-dialog v-model="statusDialog" max-width="500px">
      <v-card class="glass-effect">
        <v-card-title>
          <span class="headline">تغییر وضعیت سفارش</span>
        </v-card-title>
        <v-card-text>
          <v-select
              v-model="newStatus"
              :items="availableStatusTransitions"
              item-text="text"
              item-value="value"
              label="وضعیت جدید"
              required
          ></v-select>
          <v-textarea
              v-model="statusChangeNote"
              label="یادداشت (اختیاری)"
              rows="2"
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="statusDialog = false">
            انصراف
          </v-btn>
          <v-btn color="blue darken-1" @click="confirmStatusChange" :loading="statusLoading">
            تایید
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import axios from 'axios';
import moment from 'moment-jalaali';

export default {
  name: 'OrderManagementTable',
  data() {
    return {
      url: "product/product/all",
      filters: {},
    };
  },
  computed: {
    dateRangeText() {
      if (!this.dateRange || this.dateRange.length === 0) return '';
      if (this.dateRange.length === 1) return this.formatDate(this.dateRange[0]);
      return `${this.formatDate(this.dateRange[0])} - ${this.formatDate(this.dateRange[1])}`;
    },
    availableStatusTransitions() {
      if (!this.currentOrder) return [];
      return this.statusTransitions[this.currentOrder.status] || [];
    },
    filteredOrders() {
      let filtered = this.orders;

      // Apply status filter
      if (this.statusFilter.length > 0) {
        filtered = filtered.filter(order => this.statusFilter.includes(order.status));
      }

      // Apply date range filter
      if (this.dateRange.length === 1) {
        const date = moment(this.dateRange[0]);
        filtered = filtered.filter(order => moment(order.date_time).isSame(date, 'day'));
      } else if (this.dateRange.length === 2) {
        const startDate = moment(this.dateRange[0]);
        const endDate = moment(this.dateRange[1]);
        filtered = filtered.filter(order =>
            moment(order.date_time).isBetween(startDate, endDate, null, '[]')
        );
      }

      // Apply tracking code filter
      if (this.trackingFilter) {
        const searchTerm = this.trackingFilter.toLowerCase();
        filtered = filtered.filter(order =>
            order.exuni_tracking_code.toLowerCase().includes(searchTerm)
        );
      }

      // Apply customer filter
      if (this.customerFilter) {
        const searchTerm = this.customerFilter.toLowerCase();
        filtered = filtered.filter(order =>
            order.customer.name.toLowerCase().includes(searchTerm)
        );
      }

      return filtered;
    },
  },
  mounted() {
    this.fetchOrders();
  },
  methods: {
    async fetchOrders() {
      this.loading = true;
      this.request({
        url: this.endpoint(`product/product/all`),
        method: "get",
        success: (data) => {
          this.orders = data;
          this.loading = false
        },
      });
    },
    getStatusColor(status) {
      const colors = {
        pe: 'orange',    // Pending
        pa: 'blue',      // Paid
        pr: 'indigo',    // Processing
        sh: 'purple',    // Shipped
        de: 'green',     // Delivered
        ca: 'red',       // Cancelled
        re: 'brown',    // Returns
      };
      return colors[status] || 'grey';
    },
    getStatusText(status) {
      const statusMap = {
        pe: 'در انتظار پرداخت',
        pa: 'جاری',
        pr: 'درحال بسته بندی',
        sh: 'ارسال شده',
        de: 'تحویل شده',
        ca: 'لغو شده',
        re: 'مرجوعی',
      };
      return statusMap[status] || status;
    },
    formatPrice(price) {
      return new Intl.NumberFormat('fa-IR', {
        style: 'currency',
        currency: 'IRR',
      }).format(price).replace('ریال', 'تومان');
    },
    formatDate(date) {
      return moment(date).format('jYYYY/jMM/jDD HH:mm');
    },
    viewOrder(order) {
      this.$router.push(`/orders/${order.id}`);
    },
    editOrder(order) {
      this.$router.push(`/orders/${order.id}/edit`);
    },
    changeStatusDialog(order) {
      this.currentOrder = order;
      this.newStatus = null;
      this.statusChangeNote = '';
      this.statusDialog = true;
    },
    async confirmStatusChange() {
      if (!this.newStatus) {
        this.$toast.warning('لطفا وضعیت جدید را انتخاب کنید');
        return;
      }

      this.statusLoading = true;
      try {
        await axios.post(`/api/orders/${this.currentOrder.id}/change-status/`, {
          new_status: this.newStatus,
          note: this.statusChangeNote,
        });

        this.$toast.success('وضعیت سفارش با موفقیت تغییر کرد');
        this.fetchOrders();
        this.statusDialog = false;
      } catch (error) {
        console.error('Error changing status:', error);
        this.$toast.error('خطا در تغییر وضعیت سفارش');
      } finally {
        this.statusLoading = false;
      }
    },
    async applyBulkAction() {
      if (!this.bulkAction) {
        this.$toast.warning('لطفا یک عملیات را انتخاب کنید');
        return;
      }

      if (this.bulkAction === 'change_status') {
        this.currentOrder = this.selected[0]; // For status transitions
        this.statusDialog = true;
        return;
      }

      this.bulkLoading = true;
      try {
        const orderIds = this.selected.map(order => order.id);

        switch (this.bulkAction) {
          case 'send_email':
            await axios.post('/api/orders/bulk-email/', { order_ids: orderIds });
            this.$toast.success('ایمیل‌ها با موفقیت ارسال شدند');
            break;

          case 'download_invoice':
            // This would typically trigger a file download
            window.open(`/api/orders/bulk-invoice/?order_ids=${orderIds.join(',')}`, '_blank');
            break;

          case 'delete':
            const confirmed = await this.$confirm(
                'آیا از حذف سفارشات انتخاب شده اطمینان دارید؟ این عمل قابل بازگشت نیست.',
                { title: 'تایید حذف', buttonTrueText: 'حذف', buttonFalseText: 'انصراف' }
            );
            if (confirmed) {
              await axios.post('/api/orders/bulk-delete/', { order_ids: orderIds });
              this.$toast.success('سفارشات با موفقیت حذف شدند');
              this.fetchOrders();
              this.selected = [];
            }
            break;
        }
      } catch (error) {
        console.error('Error performing bulk action:', error);
        this.$toast.error('خطا در انجام عملیات گروهی');
      } finally {
        this.bulkLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.glass-effect {
  background: rgba(255, 255, 255, 0.8) !important;
  backdrop-filter: blur(10px);
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;
}

.search-field {
  max-width: 300px;
}

.bulk-actions {
  background: rgba(0, 0, 0, 0.03);
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  padding: 12px 16px;
}

.v-data-table {
  border-radius: 8px;
  overflow: hidden;
}

.v-card__title {
  padding-bottom: 0;
}

.v-card__text {
  padding-top: 0;
}

@media (max-width: 960px) {
  .search-field {
    max-width: 100%;
    margin-top: 10px;
  }
}
</style>